import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ShopProductCategory = ({
  categories,
  selectedCategories,
  onCategoryChange,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleCategoryChange = (event, category) => {
    if (category === '') {
      onCategoryChange([]);
      return;
    }

    let updatedCategories = [...(selectedCategories || [])];

    if (event.target.checked) {
      if (!updatedCategories.includes(category)) {
        updatedCategories.push(category);
      }
    } else {
      updatedCategories = updatedCategories.filter((item) => item !== category);
    }

    onCategoryChange(updatedCategories);
  };

  const normalizedCategories = (categories || []).map((category) =>
    typeof category === 'string' ? { code: category, count: null } : category
  );

  return (
    <div className="sidebar-widget">
      <h4
        className="pro-sidebar-title"
        onClick={() => setIsOpen((prev) => !prev)}
        style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        {t('Category')}
        <span style={{ fontSize: '12px' }}>{isOpen ? '▲' : '▼'}</span>
      </h4>
      {isOpen && (
        <div className="sidebar-widget-list mt-30">
          {categories && categories.length > 0 ? (
            <ul>
              <li>
                <label className="sidebar-widget-list-left">
                  <input
                    type="checkbox"
                    className={selectedCategories?.includes('') ? 'active' : ''}
                    onChange={(event) => handleCategoryChange(event, '')}
                    checked={selectedCategories?.length === 0}
                  />
                  <span className="checkmark" />
                  <span className="checkmark-text">{t('All')}</span>
                </label>
              </li>
              {normalizedCategories.map(({ code, count }, key) => (
                <li key={key}>
                  <label className="sidebar-widget-list-left">
                    <input
                      type="checkbox"
                      className={selectedCategories?.includes(code) ? 'active' : ''}
                      onChange={(event) => handleCategoryChange(event, code)}
                      checked={selectedCategories?.includes(code)}
                    />
                    <span className="checkmark" />
                    <span className="checkmark-text">
                      {t(code, { defaultValue: code })}
                      {count !== null && (
                        <span style={{ color: 'var(--neutral-60)', marginLeft: 4, fontSize: '0.85em' }}>({count})</span>
                      )}
                    </span>
                  </label>
                </li>
              ))}
            </ul>
          ) : (
            <p>{t('No categories found')}</p>
          )}
        </div>
      )}
    </div>
  );
};

ShopProductCategory.propTypes = {
  categories: PropTypes.array,
  onCategoryChange: PropTypes.func,
  selectedCategories: PropTypes.array,
};

export default ShopProductCategory;